import OptionHOC from '@platform/react/hoc/autocomplete/option'
import { Grid } from '@mui/material'
import { getFirstItem } from 'lib/util'
import AvatarImage from 'ui/Element/Image/Avatar'
import Text from 'ui/Element/Text'
import { getSubLabel } from 'lib/util/string'

const styles = () => ({
  option: {
    gap: '0.75rem',
  },
  subLabel: {
    gap: '0.25rem',
  },
  icon: {
    width: '3rem',
    height: '3rem',
  },
})

/**
 * Displays the name of a service item alongside its serial number and product name as a sublabel.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
const ServiceItemOption = (classes, props = {}) => {
  const { option, labels } = props
  const {
    value: { serial = '', name = '-' } = {},
    refs: { product = {} } = {},
  } = option || {}
  const { serial: serialLabel = null } = labels

  const { avatar } = product?.refs || {}
  const attachment = getFirstItem(avatar)

  const subLabel = getSubLabel(Text, [serialLabel, serial])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.option}
    >
      <Grid
        item
        xs={'auto'}
        className={classes.icon}
      >
        <AvatarImage
          shape={'circle'}
          attachment={attachment}
          fallbackIcon={{
            name: 'device',
            size: '1.5rem',
            color: 'text.regular',
            background: 'gray.960',
          }}
        />
      </Grid>
      <Grid
        item
        xs={'auto'}
      >
        <Grid
          container
          height={'100%'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={name}
            variant={'14/bold'}
            color={'black.main'}
          />
          {serialLabel && serial && (
            <Grid
              item
              container
              ms={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OptionHOC(ServiceItemOption, styles)
